import { z } from "zod";

export const tipoProdutoSchema = z.object({
  nome: z.string().min(1, "Nome é obrigatório"),
  descricao: z.string().optional(),
  categoria: z.string().optional(),
  preco_base: z.number().min(0, "Preço deve ser maior ou igual a zero"),
  unidade_venda: z.string().min(1, "Unidade de venda é obrigatória"),
  tamanho: z.string().trim().max(50, "Tamanho deve ter no máximo 50 caracteres").optional().nullable(),
  peso: z.number().min(0.001, "Peso mínimo: 0,001 kg").max(999999, "Peso máximo excedido").optional().nullable(),
  preco_custo: z.number().min(0, "Preço de custo não pode ser negativo").max(999999.99, "Valor máximo excedido").optional().nullable(),
  preco_venda: z.number().min(0, "Preço de venda não pode ser negativo").max(999999.99, "Valor máximo excedido").optional().nullable(),
  ativo: z.boolean().default(true),
  observacoes: z.string().optional(),
})
.refine(
  (data) => {
    if (data.preco_venda && !data.preco_custo) return false;
    return true;
  },
  { message: "Informe o preço de custo antes de definir o preço de venda", path: ["preco_custo"] }
)
.refine(
  (data) => {
    if (data.preco_venda && data.preco_custo && data.preco_venda < data.preco_custo) {
      return false;
    }
    return true;
  },
  { message: "Preço de venda não pode ser menor que o preço de custo", path: ["preco_venda"] }
);

export type TipoProdutoFormData = z.infer<typeof tipoProdutoSchema>;
